import { Service, Inject } from 'vue-di-container';

import { IntegrationResult } from '@/models/Result';
import AxiosService from '@/services/axios';
import LoaderService from '@/services/loader';
import { City, ContractCloseReason } from '@/models/lookup.model';

@Service()
export default class LookupService {
  @Inject(AxiosService) public axiosService!: AxiosService;
  @Inject(LoaderService) public loaderService!: LoaderService;

  public async getContractCloseReasons(): Promise<IntegrationResult<ContractCloseReason[]>> {
    this.loaderService.ShowLoader();
    try {
      const url = 'api/Lookup/GetContractCloseReasons';
      const result = await this.axiosService.axiosInstance.get(url);
      this.loaderService.HideLoader();
      return result.data;
    } catch (e) {
      throw e;
    } finally {
      this.loaderService.HideLoader();
    }
  }

  public async getCities(): Promise<IntegrationResult<City[]>> {
    this.loaderService.ShowLoader();
    try {
      const url = 'api/Lookup/GetCities';
      const result = await this.axiosService.axiosInstance.get(url);
      this.loaderService.HideLoader();
      return result.data;
    } catch (e) {
      throw e;
    } finally {
      this.loaderService.HideLoader();
    }
  }
}
